import * as React from 'react';
import { EditProfileDialogModel } from './model/ProfileSettingsModel';
import { ProfileSettingsController } from './controller/ProfileSettingsController';
import { Dialog } from 'components/dialog';
import { TextField } from 'components/input/TextField';
import { Button } from '@material-ui/core';

export class EditProfileDialog extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        var m = props.model;
        this.state = {
            name: m.name == null ? "" : m.name,
            position: m.position == null ? "" : m.position,
            bio: m.bio == null ? "" : m.bio,
            chat: m.chat == null ? "" : m.chat,
            workPhone: m.workPhone == null ? "" : m.workPhone,
            homePhone: m.homePhone == null ? "" : m.homePhone,
            address: m.address == null ? "" : m.address,
            memberSince: m.memberSince == null ? "" : m.memberSince
        };

        this.handleCancelButtonClicked = this.handleCancelButtonClicked.bind(this);
        this.handleSaveButtonClicked = this.handleSaveButtonClicked.bind(this);
    }

    private handleCancelButtonClicked() {
        this.props.controller.onEditProfileCancelClicked();
    }

    private handleSaveButtonClicked() {
        var m = this.props.model;
        m.name = this.state.name;
        m.position = this.state.position;
        m.bio = this.state.bio;
        m.chat = this.state.chat;
        m.workPhone = this.state.workPhone;
        m.homePhone = this.state.homePhone;
        m.address = this.state.address;
        m.memberSince = this.state.memberSince;
        this.props.controller.onEditProfileSaveClicked(m);
    }

    public render() {
        return (
            <Dialog title="Edit profile" desc="Fill the form below to update your profile information.">
                <TextField label="Name" value={this.state.name} desc="The name that will be shown to other team members." error={this.props.model.nameError} onChange={(v) => { this.setState({ name: v }) }} />
                <TextField label="Position" value={this.state.position} desc="Your position in the team. Eg.: Senior Software Developer" onChange={(v) => { this.setState({ position: v }) }} />
                <TextField label="Bio" value={this.state.bio} desc="Introduce yourself to the team." multiline={true} onChange={(v) => { this.setState({ bio: v }) }} />
                <TextField label="Chat" value={this.state.chat} desc="Your chat ID which can be used to contact you." onChange={(v) => { this.setState({ chat: v }) }} />
                <TextField label="Phone (work)" value={this.state.workPhone} desc="The number of your work phone." onChange={(v) => { this.setState({ workPhone: v }) }} />
                <TextField label="Phone (private)" value={this.state.homePhone} desc="The number of your home phone." onChange={(v) => { this.setState({ homePhone: v }) }} />
                <TextField label="Address" value={this.state.address} desc="Your address" onChange={(v) => { this.setState({ address: v }) }} />
                <TextField label="Member since" value={this.state.memberSince} desc="The date when you joined this company." onChange={(v) => { this.setState({ memberSince: v }) }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '100%' }}>
                    <Button color="secondary" onClick={this.handleCancelButtonClicked}>Cancel</Button>
                    <Button style={{ marginLeft: '8px' }} color="primary" variant="contained" onClick={this.handleSaveButtonClicked}>Save</Button>
                </div>
            </Dialog>
        );
    }

}

export interface Props {

    model: EditProfileDialogModel;
    controller: ProfileSettingsController;

}

interface State {

    name: string;
    position: string;
    bio: string;
    chat: string;
    workPhone: string;
    homePhone: string;
    address: string;
    memberSince: string;

}
